import React from "react";
import { useLang } from "../i18n/LanguageContext";

export function LanguageSwitcher({ testId = "language-switcher" }) {
  const { lang, setLang } = useLang();
  const base = "px-2 py-1 text-xs tracking-[0.18em] uppercase transition-colors";
  return (
    <div
      className="inline-flex items-center border border-border-light"
      data-testid={testId}
    >
      <button
        type="button"
        onClick={() => setLang("fr")}
        className={`${base} ${lang === "fr" ? "bg-charcoal text-white" : "text-charcoal hover:text-gold"}`}
        data-testid="lang-fr"
      >
        FR
      </button>
      <button
        type="button"
        onClick={() => setLang("ar")}
        className={`${base} border-s border-border-light ${lang === "ar" ? "bg-charcoal text-white" : "text-charcoal hover:text-gold"}`}
        data-testid="lang-ar"
      >
        AR
      </button>
    </div>
  );
}

export default LanguageSwitcher;
